/**
 * Adresse de l'API.
 *
 * Elle etait recopiee dans trois modules avec le meme fallback localhost. Un
 * build de production dont la variable manque partait alors interroger une
 * machine de developpement qui n'existe pas : sync, entitlements et codes
 * echouaient en silence, chacun a sa facon, sans que rien ne dise pourquoi.
 *
 * En production, l'absence de REACT_APP_API_URL est donc une erreur bruyante et
 * immediate, au chargement du module, plutot qu'une serie de requetes perdues.
 * En developpement, le fallback local reste commode.
 */

const FALLBACK_DEV_URL = 'http://localhost:3001';

function resolve() {
  const configured = (process.env.REACT_APP_API_URL || '').trim();
  if (configured) return configured.replace(/\/+$/, '');
  if (process.env.NODE_ENV === 'production') {
    throw new Error(
      'REACT_APP_API_URL manquant : un build de production ne peut pas viser localhost. ' +
        'Definir la variable avant `npm run build`.'
    );
  }
  return FALLBACK_DEV_URL;
}

export const API_URL = resolve();
